module.exports = {
  WEBDRIVERIO_INPUT_ELEMENT: '.wc-shellinput',
  WEBDRIVERIO_OUTPUT_ELEMENT: '//div[@class=\'wc-message wc-message-from-bot\']//div[@class=\'wc-message-content\' and not(descendant::div[@class=\'wc-typing\'])]'
}
